import { Amount, Ltr } from '@/components/amount';
import { cn } from '@/lib/utils';

import type { DocumentCardModel } from './types';

/**
 * One row of the list: the code and the chip on the first line, who it is
 * with and how much on the second. A real `<button>` (NFR-36) — the whole
 * card is the click, and `aria-pressed` says which one is open beside it.
 */
export function DocumentCard({
  model,
  selected,
  onSelect,
}: {
  model: DocumentCardModel;
  selected: boolean;
  onSelect: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onSelect}
      aria-pressed={selected}
      className={cn(
        'grid w-full gap-1 rounded-lg border border-transparent px-3 py-2 text-start transition-colors hover:bg-muted/60',
        selected && 'border-primary/40 bg-primary/5',
      )}
    >
      <span className="flex items-center justify-between gap-2">
        <Ltr value={model.code} className="font-mono text-sm text-muted-foreground" />
        {model.chip}
      </span>
      <span className="flex items-center justify-between gap-2 text-sm">
        <span className="font-medium">{model.title}</span>
        {model.amount ? <Amount value={model.amount.value} currency={model.amount.currency} /> : null}
      </span>
      {model.meta !== undefined && model.meta !== null ? (
        <span className="text-xs text-muted-foreground">{model.meta}</span>
      ) : null}
    </button>
  );
}
